import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import GoogleCallback from './pages/GoogleCallback';
import { LocaleProvider } from './i18n/LocaleContext';
import { AuthProvider } from './auth/AuthContext';
import DevBanner from './components/DevBanner';
import './styles/main.scss';

function App() {
  return (
    <LocaleProvider>
      <DevBanner />
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            {/* One route for every page (/dashboard/briefs …), so switching
                pages keeps the Dashboard mounted — see Dashboard.js. */}
            <Route path="/dashboard/*" element={<Dashboard />} />
            {/* Google OAuth popup lands here; it relays the token to the login tab. */}
            <Route path="/google-callback" element={<GoogleCallback />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </LocaleProvider>
  );
}

export default App;
